import {
  IOverleveringChecklistReport,
  OVERLEVERING_CHECKLIST_TYPES,
} from "@mcapps/shared/startupChecklists/templates/901-overlevering/901Schema";

export const ensureOverleveringChecklistReport = (
  data: Partial<IOverleveringChecklistReport> | null | undefined,
): IOverleveringChecklistReport => ({
  overleveringChecklistType: data?.overleveringChecklistType ?? OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING,
  rows: data?.rows ?? [],
});
